// How measured numbers are shown: one decimal, like the template's summary.
const ONE_DP = new Intl.NumberFormat('en-AU', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

export const formatQuantity = (value: number): string => ONE_DP.format(value);

export const formatHours = (value: number): string => `${ONE_DP.format(value)} h`;

/** hig_measuredhours / hig_assessedhours are 2-decimal columns. */
const STORED_HOURS_PLACES = 2;

/**
 * An area's hours as CRM stores them (2 decimals). Area totals are shown from
 * this, so the total in the area and the figure in the area list — which is
 * the stored value — round the same way (10.745 h is stored 10.75, shown 10.8 h
 * in both places, not 10.7 h in one).
 */
export const storedHours = (value: number): number => Number(value.toFixed(STORED_HOURS_PLACES));

// Pricing figures: the template's two decimals; money in dollars and cents.
const TWO_DP = new Intl.NumberFormat('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const MONEY = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });

export const formatTwo = (value: number): string => TWO_DP.format(value);

export const formatMoney = (value: number): string => MONEY.format(value);

/** An option's sell price, or a dash while the REVIEW holds it back (PRICING.md "The REVIEW checklist"). */
export const formatSell = (value: number, shown: boolean): string => (shown ? formatMoney(value) : '—');

const PERCENT = 100;

export const formatPercent = (fraction: number): string => `${ONE_DP.format(fraction * PERCENT)}%`;

/** Whole numbers with a thousands separator: the Schedule of Work cover's m² and litres. */
const WHOLE = new Intl.NumberFormat('en-AU', { maximumFractionDigits: 0 });

export const formatWhole = (value: number): string => WHOLE.format(value);
